import {UserProfileState} from "@/vuex/modules/profile-module/state";
import {MutationTree} from "vuex";

const mutations: MutationTree<UserProfileState> = {}

export default mutations;